<div [ngStyle]="scoreStyle" [innerHTML]="'Score: ' + this.score.score" style="position:absolute; z-index:50; color:rgba(99,199,77,1);"></div>
